import { mapState } from 'pinia';
import { get } from 'lodash-es';
import {
  useAssetStore,
} from '@/stores';

export default {
  data() {
    return {
      imageInfo: null,
    };
  },
  watch: {
    imageUrl() {
      if (this.imageInfo) return;

      // only apply the image src update if there is a valid thumbail image found
      if (this.validThumbnailUrl) {
        const image = new Image();
        image.onload = () => {
          // Load size and aspect ratio for the thumbnail image.
          this.imageInfo = {
            imageAspectRatio: image.height / image.width,
            imageHeight: image.height,
            imageWidth: image.width,
          };
        };
        image.src = this.validThumbnailUrl;
      }
    },
  },
  computed: {
    ...mapState(useAssetStore, [
      'assets',
    ]),
    canEditImage() {
      return !!(['asset', 'upload'].includes(this.moduleData?.type)
        && this.moduleData?.options?.shape
        && this.cachedAsset?.group === 'image'
        && this.mode === 'EDIT'
        && this.active);
    },
    canMoveImage() {
      return this.canEditImage && !!this.imageInfo;
    },
    cachedAsset() {
      return this.assets[this.imageAssetId];
    },
    imageAssetId() {
      return get(this, 'moduleData.options.asset_id');
    },
    imageOffset() {
      return get(this, 'moduleData.options.image_offset');
    },
    imageUrl() {
      return this.validThumbnailUrl || null;
    },
  },
};
